export default {"src":"/_next/static/media/cbre.c8159cab.svg","height":25,"width":94,"blurWidth":0,"blurHeight":0};